/**
 * Represents a zeus.apollon_fk_conf.conf.projekt.feldgruppen[x].felder value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { Model, type MutationsObject } from '@kp/js-model';
import dayjs, { Dayjs } from 'dayjs';

export const TEXT = null;

export class ProjektFeld extends Model {
    public feld_id: number | null = null
    public feld_name: string | null = null
    public db_type: string | null = null
    public ist_link: boolean = false
    public link_tabellenname: string | null = null
    public link_id_field: string | null = null
    public link_value_field: string | null = null
    public linktabelle_produktkategorie_id: number | null = null
    public ist_werteliste: boolean = false
    public werteliste_tabelle: string | null = null
    public werteliste_id_field: string | null = null
    public werteliste_value_field: string | null = null
    public label: string | null = null
    public required: boolean | null = null
    public hilfetext: string | null = null
    public warnmeldung: string | null = null
    public value_from: number | null = null
    public value_to: number | null = null
    public einreichung: boolean = false
    public einreichung_from: Dayjs | null = null
    public einreichung_to: Dayjs | null = null
    public abschluss: boolean = false
    public abschluss_from: Dayjs | null = null
    public abschluss_to: Dayjs | null = null
    public zeus_feld: string | null = null

    public mutations(): MutationsObject {
        return {
            feld_id: (id: number | null) => (Number(id) > 0 ? Number(id) : null),
            einreichung_from: (date: Dayjs | null) => (date ? dayjs(date) : null),
            einreichung_to: (date: Dayjs | null) => (date ? dayjs(date) : null),
            abschluss_from: (date: Dayjs | null) => (date ? dayjs(date) : null),
            abschluss_to: (date: Dayjs | null) => (date ? dayjs(date) : null),
            db_type: (val) => {
                switch (val) {
                    case 'character varying':
                        return 'string';
                    case 'text':
                        return 'text';
                    case 'boolean':
                        return 'boolean';
                    case 'integer':
                        return 'integer';
                    case 'real':
                        return 'float';
                    case 'date':
                        return 'date';
                    case 'ja_nein_unknown':
                        return 'ja_nein_unknown';
                    case 'ja_nein_teilweise':
                        return 'ja_nein_teilweise';
                    default:
                        console.warn('cannot find db_type, given value: ' + val);
                        return 'string';
                }
            }
        };
    }
}
